// extracted by mini-css-extract-plugin
export default {"spoiler":"Spoiler_spoiler__JeSpy","active":"Spoiler_active__8AmsI","spoilerContent":"Spoiler_spoilerContent__mr+cg","spoilerTitle":"Spoiler_spoilerTitle__oAp4M"};